import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MainLayout from './MainLayout';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Box, IconButton, ListItemButton } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MenuIcon from '@mui/icons-material/Menu';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PeopleIcon from '@mui/icons-material/People';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HistoryIcon from '@mui/icons-material/History';
import AssignmentIcon from '@mui/icons-material/Assignment';

const expandedWidth = 240;
const collapsedWidth = 65;

function AdminBaseLayout({ children }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleDrawerToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const menuItems = [
    { path: '/admin/view', icon: DashboardIcon, text: 'Dashboard' },
    { path: '/admin/balance', icon: AccountBalanceWalletIcon, text: 'Saldo' },
    { path: '/admin/users', icon: PeopleIcon, text: 'Usuários' },
    { path: '/admin/partners', icon: HandshakeIcon, text: 'Parceiros' },
    { path: '/admin/logs', icon: HistoryIcon, text: 'Logs' },
    { path: '/admin/audit', icon: AssignmentIcon, text: 'Auditoria' },
  ];

  const renderMenuItems = (showText = false) => (
    <List>
      {menuItems.map(({ path, icon: Icon, text }) => (
        <ListItem key={path} button component={Link} to={path} sx={{ mb: 1 }}>
          <ListItemIcon>
            <Icon sx={{ color: 'white' }} />
          </ListItemIcon>
          {showText && <ListItemText primary={text} sx={{ color: 'white' }} />}
        </ListItem>
      ))}
    </List>
  );

  return (
    <MainLayout>
      <Box sx={{ display: 'flex' }}>
        <Drawer
          variant="permanent"
          sx={{
            width: collapsedWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: collapsedWidth,
              boxSizing: 'border-box',
              bgcolor: '#ff9800',
              color: 'white',
              overflowX: 'hidden',
              zIndex: 1,
            },
          }}
        >
          <Box sx={{ overflow: 'auto', mt: 8 }}>
            <IconButton
              onClick={handleDrawerToggle}
              sx={{
                color: 'white',
                mb: 2,
                ml: 1,
              }}
            >
              <MenuIcon />
            </IconButton>
            {renderMenuItems()}
          </Box>
        </Drawer>

        {/* Expandable overlay drawer */}
        <Drawer
          variant="temporary"
          open={isExpanded}
          onClose={handleDrawerToggle}
          sx={{
            width: expandedWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: expandedWidth,
              boxSizing: 'border-box',
              bgcolor: '#ff9800',
              color: 'white',
              transition: 'width 0.2s ease-in-out',
              overflowX: 'hidden',
              zIndex: 2,
            },
          }}
        >
          <Box sx={{ overflow: 'auto', mt: 8 }}>
            <IconButton
              onClick={handleDrawerToggle}
              sx={{
                color: 'white',
                mb: 2,
                ml: 1,
              }}
            >
              <MenuIcon />
            </IconButton>
            {renderMenuItems(true)}
          </Box>
        </Drawer>

        <Box component="main" sx={{ flexGrow: 1, p: 0 }}>
          {children}
        </Box>
      </Box>
    </MainLayout>
  );
}

export default AdminBaseLayout;